/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_TitleInputs */

const en_model_title = /** @type {(inputs: Model_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI model`)
};

const id_model_title = /** @type {(inputs: Model_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model AI`)
};

/**
* | output |
* | --- |
* | "AI model" |
*
* @param {Model_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_title = /** @type {((inputs?: Model_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_title(inputs)
	return en_model_title(inputs)
});